module.exports = __webpack_public_path__ + "img/complaint-02.d91b2bfd.png";